import CompanyInfo from './companyInfo/CompanyInfo';
import VeteranOwnerInfo from './veteranOwnerInfo/VeteranOwnerInfo';
import BusinessStructure from './businessStructure/BusinessStructure';
import BusinessCertifications from './businessCertifications/BusinessCertifications';
import FinancialDocuments from './financialDocuments/FinancialDocuments';
import BankInfo from './bankInfo/BankInfo';
import TaxInfo from './taxInfo/TaxInfo';
import EquipmentInfo from './equipmentInfo/EquipmentInfo';
import Articles from './articles/Articles';
import Declaration from './declaration/Declaration';

export {
  CompanyInfo,
  VeteranOwnerInfo,
  BusinessStructure,
  BusinessCertifications,
  FinancialDocuments,
  BankInfo,
  TaxInfo,
  EquipmentInfo,
  Articles,
  Declaration
};



// WEBPACK FOOTER //
// ./src/areas/certification/steps/index.js